import axiosInstance from '../utils/axiosConfig';

const API_BASE = '/api/knowledge-hub';

export const uploadDocument = async (file, onProgress = null, classification = '') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (classification) {
      formData.append('classification', classification);
    }

    const response = await axiosInstance.post(`${API_BASE}/upload/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading document:', error);
    throw error;
  }
};

export const createEntry = async (text, file = null, classification = '') => {
  try {
    const formData = new FormData();
    formData.append('text', text || '');
    if (file) {
      formData.append('file', file);
    }
    if (classification) {
      formData.append('classification', classification);
    }

    const response = await axiosInstance.post(`${API_BASE}/entries/new/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating entry:', error);
    throw error;
  }
};

export const getProcessingStatus = async (documentId) => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/processing-status/${documentId}/`);
    return response.data;
  } catch (error) {
    console.error('Error getting processing status:', error);
    throw error;
  }
};

export const listDocuments = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/documents/`, { params });
    return response.data;
  } catch (error) {
    console.error('Error listing documents:', error);
    throw error;
  }
};

export const getDocument = async (documentId) => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/documents/${documentId}/`);
    return response.data;
  } catch (error) {
    console.error('Error getting document:', error);
    throw error;
  }
};

export const deleteDocument = async (documentId) => {
  try {
    const response = await axiosInstance.delete(`${API_BASE}/documents/${documentId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

export const sendChatMessage = async (message, sessionId = null, partnerFilter = null, classificationFilter = null, documentIds = null) => {
  try {
    const payload = {
      message,
      session_id: sessionId,
      partner_filter: partnerFilter,
      classification_filter: classificationFilter,
    };
    if (documentIds && documentIds.length > 0) {
      payload.document_ids = documentIds;
    }
    const response = await axiosInstance.post(`${API_BASE}/chat/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};

export const downloadDocument = async (documentId) => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/download/${documentId}/`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading document:', error);
    throw error;
  }
};

export const listChatSessions = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/chat/sessions/`);
    return response.data;
  } catch (error) {
    console.error('Error listing chat sessions:', error);
    throw error;
  }
};

export const getChatSession = async (sessionId) => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/chat/sessions/${sessionId}/`);
    return response.data;
  } catch (error) {
    console.error('Error getting chat session:', error);
    throw error;
  }
};

export const deleteChatSession = async (sessionId) => {
  try {
    const response = await axiosInstance.delete(`${API_BASE}/chat/sessions/${sessionId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting chat session:', error);
    throw error;
  }
};

export const getPartnersWithDocuments = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/partners/`);
    return response.data;
  } catch (error) {
    console.error('Error getting partners:', error);
    throw error;
  }
};

export const getStats = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE}/stats/`);
    return response.data;
  } catch (error) {
    console.error('Error getting stats:', error);
    throw error;
  }
};

export const createCrmPartnerFromDocument = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_BASE}/create-crm-partner/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating CRM partner from document:', error);
    throw error;
  }
};

export const linkDocumentToPartner = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_BASE}/link-partner/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error linking document to partner:', error);
    throw error;
  }
};

// Read a document that failed again, from the file the server kept.
export const readDocumentAgain = async (documentId) => {
  const response = await axiosInstance.post(`${API_BASE}/documents/${documentId}/read-again/`);
  return response.data;
};

export default {
  uploadDocument,
  readDocumentAgain,
  createEntry,
  getProcessingStatus,
  listDocuments,
  getDocument,
  deleteDocument,
  sendChatMessage,
  downloadDocument,
  listChatSessions,
  getChatSession,
  deleteChatSession,
  getPartnersWithDocuments,
  getStats,
  createCrmPartnerFromDocument,
  linkDocumentToPartner,
};
